const fallbackTimeZone = 'UTC';

const isValidTimeZone = (timeZone?: string): timeZone is string => {
  if (!timeZone) {
    return false;
  }

  try {
    new Intl.DateTimeFormat(undefined, { timeZone });
    return true;
  } catch {
    return false;
  }
};

const resolveTimeZone = (timeZone?: string) => (isValidTimeZone(timeZone) ? timeZone : fallbackTimeZone);

// Undefined when the browser can't name the computer's time zone (Chrome reports none for zones it doesn't know)
const getRecognizedBrowserTimeZone = () => {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return isValidTimeZone(timeZone) ? timeZone : undefined;
  } catch {
    return undefined;
  }
};

const getBrowserTimeZone = () => getRecognizedBrowserTimeZone() ?? fallbackTimeZone;

// A label for the time zone that local dates and times are in. Dates still use the computer's local time when the
// browser can't name its time zone, so the label must not claim the fallback time zone.
const formatBrowserTimeZone = () => getRecognizedBrowserTimeZone()?.replace(/_/g, ' ') ?? 'Local time';

export {
  fallbackTimeZone,
  formatBrowserTimeZone,
  getBrowserTimeZone,
  getRecognizedBrowserTimeZone,
  isValidTimeZone,
  resolveTimeZone,
};
